import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import FormField from './../FormField';
import TitleHeader from '../../TitleHeader';
import styles from './ShortDescFieldset.scss';
import {CardBody} from 'reactstrap';

const ShortDescFieldset = ({ formErrors }) => (
  <Fragment>
    <TitleHeader title="Event Summary" infoUrl="https://support.evvnt.com/hc/en-us/articles/216668038-Details-Creating-a-great-event-summary" required/>
    <CardBody>
      <div className={`row + ${styles.description}`}>
        <div className="col-12">
          <FormField
            error={formErrors.get('summary')}
            name="summary"
            component="textarea"
            type="text"
            className="form-control"
            placeholder="Enter a short summary of key event details, this will get displayed in lists of events across our network of publishers."
            maxLength={200}
            normalize={val => val.substr(0, 200)}
            required
          />
        </div>
      </div>
    </CardBody>
    <TitleHeader title="Event Description" infoUrl="https://support.evvnt.com/hc/en-us/articles/360020922393-Details-Creating-an-awesome-description" required/>
    <CardBody >
      <div className={`row + ${styles.description}`}>
        <div className="col-12">
          <FormField
            error={formErrors.get('description')}
            name="description"
            component="textarea"
            type="text"
            className="form-control"
            placeholder="Enter a more detailed description of your event, including what will be occurring, who should go and all other major details. This will be displayed on event full details pages across our network of publishers."
            maxLength={5000}
            normalize={val => val.substr(0, 5000)}
            required
          />
        </div>
      </div>
      <div className="mb-3 font-italic">
        Add artist names by clicking "Advanced Form" above
      </div>
    </CardBody>
  </Fragment>
);

ShortDescFieldset.propTypes = {
  formErrors: PropTypes.object,
};

export default ShortDescFieldset;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/fieldsets/ShortDescFieldset.jsx